import * as React from "react";
import s from "./place-carousel.scss";
import Icon from "#components/icon";

interface PlaceCarouselProps {
	places: Array<{ id: string; name: string }>;
	currentIndex: number;
	onChangeIndex: (index: number) => void;
}

export function PlaceCarousel({
	places,
	currentIndex,
	onChangeIndex,
}: PlaceCarouselProps) {
	const canGoPrevious = currentIndex > 0;
	const canGoNext = currentIndex < places.length - 1;

	const handlePrevious = () => {
		if (canGoPrevious) {
			onChangeIndex(currentIndex - 1);
		}
	};

	const handleNext = () => {
		if (canGoNext) {
			onChangeIndex(currentIndex + 1);
		}
	};

	if (places.length <= 1) {
		return null;
	}

	return (
		<div className={s.placeCarousel}>
			<button
				className={s.carouselButton}
				onClick={handlePrevious}
				disabled={!canGoPrevious}
				aria-label="Place anterior"
			>
				<Icon icon="chevron-back" />
			</button>

			<div className={s.carouselContent}>
				<span className={s.placeName}>{places[currentIndex].name}</span>
				<span className={s.placeIndicator}>
					{currentIndex + 1} / {places.length}
				</span>
			</div>

			<button
				className={s.carouselButton}
				onClick={handleNext}
				disabled={!canGoNext}
				aria-label="Próximo place"
			>
				<Icon icon="chevron-right" />
			</button>
		</div>
	);
}
